
import { format } from "date-fns";
import { EventObject } from "./types";

interface MonthViewProps {
	currentDate: Date;
}

export const MonthView = ({ currentDate }: MonthViewProps) => {
	return (
		<div className="h-full flex flex-col items-center justify-center">
			<h3 className="font-medium">Month View</h3>
			<p className="text-muted-foreground">
				{format(currentDate, 'MMMM yyyy')}
			</p>
			<p className="text-sm text-muted-foreground mt-4">
				Switch to Week view to see a detailed calendar with time slots
			</p>
		</div>
	);
};
